import Vue from 'vue/dist/vue.min.js';

const EventBus = new Vue();

export default EventBus;